import { render, staticRenderFns } from "./ordinaryAiLoading.vue?vue&type=template&id=3cc2cba2&scoped=true&"
import script from "./ordinaryAiLoading.vue?vue&type=script&lang=ts&"
export * from "./ordinaryAiLoading.vue?vue&type=script&lang=ts&"
import style0 from "./ordinaryAiLoading.vue?vue&type=style&index=0&id=3cc2cba2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2cba2",
  null
  
)

export default component.exports